import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { vibrate } from "@/lib/quantum";

// A breathing guide: four counts in, six counts out, with a soft pulse on each turn where phones support it.
export default function BreathCircle({ active, haptics = true }) {
  const [phase, setPhase] = useState("in");
  const timer = useRef(null);
  useEffect(() => {
    if (!active) {
      setPhase("in");
      return undefined;
    }
    let p = "in";
    const turn = () => {
      setPhase(p);
      if (haptics) vibrate(p === "in" ? 25 : [15, 60, 15]);
      timer.current = setTimeout(() => {
        p = p === "in" ? "out" : "in";
        turn();
      }, p === "in" ? 4000 : 6000);
    };
    turn();
    return () => clearTimeout(timer.current);
  }, [active, haptics]);
  return (
    <div data-testid="qi-breath-circle" className="relative mx-auto w-40 h-40 flex items-center justify-center">
      <motion.span
        aria-hidden
        className="absolute inset-0 rounded-full border border-[#E8838E]/50 bg-[radial-gradient(circle,rgba(232,131,142,0.28),rgba(194,65,79,0.06)_60%,transparent_72%)]"
        animate={{ scale: active ? (phase === "in" ? 1 : 0.55) : 0.7 }}
        transition={{ duration: phase === "in" ? 4 : 6, ease: "easeInOut" }}
      />
      <span data-testid="qi-breath-phase" className="relative font-tt-mono text-[12px] uppercase tracking-[0.25em] text-[#F2E8DF]">{active ? (phase === "in" ? "Breathe in" : "Breathe out") : "Ready"}</span>
    </div>
  );
}
